// src/modules/reports/help/components/ChartHelpButton.tsx
import { memo } from 'react';
import { IconButton } from '@mui/material';
import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {
  InventoryHelpDashboard,
  inventoryHelpHref,
} from '../constants/help-anchors';

type Props = {
  helpDashboard: InventoryHelpDashboard;
  helpId: string;
};

const ChartHelpButton = ({ helpDashboard, helpId }: Props) => {
  const { t } = useTranslation('report');
  return (
    <IconButton
      component={Link}
      to={inventoryHelpHref(helpDashboard, helpId)}
      size='small'
      aria-label={t('help.tooltip')}
      sx={{
        position: 'absolute',
        top: 8,
        right: 0,
        zIndex: 1,
        color: 'text.secondary',
        '&:hover': { color: 'primary.main' },
      }}
    >
      <HelpOutlineOutlinedIcon fontSize='small' />
    </IconButton>
  );
};

export default memo(ChartHelpButton);
